import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
var MEDIUM = 'medium';
var TINY = 'tiny';
export var Component = function Component(_ref) {
  var children = _ref.children,
      isCompact = _ref.isCompact,
      size = _ref.size,
      weight = _ref.weight,
      className = _ref.className;
  return React.createElement("p", {
    className: classnames(weight, className, {
      tiny: size === TINY,
      'is-compact': isCompact
    })
  }, children);
};
Component.displayName = 'Paragraph';
Component.defaultProps = {
  className: null,
  isCompact: false,
  size: MEDIUM,
  weight: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  isCompact: PropTypes.bool,
  size: PropTypes.oneOf([MEDIUM, TINY]),
  weight: PropTypes.oneOf(['heavy', 'light'])
} : {};